import { useState } from 'react';

import { createStore } from 'jotai';

import { FormyProvider } from '../types/form';
import { context } from './context';

const FormContextProvider = ({
  children,
  formScrollableRef,
}: {
  children: React.ReactNode;
  formScrollableRef: FormyProvider['formScrollableRef'];
}) => {
  const [store] = useState(() => createStore());

  return <context.Provider value={{ store, formScrollableRef }}>{children}</context.Provider>;
};

export { FormContextProvider };
